import { getSelectedSound } from 'store/selectedBubble/reducer';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadSounds, setSoundLoaded } from 'store';

const loadAudio = (id: number, url: string, res: any, reject: any) => {
  const audio = new Audio();
  audio.src = url;
  audio.onloadeddata = () => {
    res({ [id]: audio });
  };
  audio.onerror = () => reject({ [id]: null });
};

const useSoundLoad = ({ play }: { play: boolean }) => {
  const currentSoundID = useSelector(getSelectedSound);
  const dispatch = useDispatch();
  const [soundSet, setSoundSet] = useState<any>({});
  const [_, setPrevSound] = useState<any>('');

  useEffect(() => {
    const preload = async () => {
      const { payload: soundArray, error }: any = await dispatch(loadSounds());
      if (error) {
        return;
      }
      const fff = soundArray.map(
        ({ id, url }: any) =>
          // eslint-disable-next-line no-promise-executor-return
          new Promise((resolve, reject) => loadAudio(id, url, resolve, reject))
      );
      const promisedAudio = await Promise.allSettled(fff);

      let load = true;
      const saveSound = promisedAudio.reduce((a, b) => {
        if (b.status !== 'fulfilled') {
          load = false;
        } else {
          return { ...a, ...(b.value || {}) };
        }
        return a;
      }, {});
      setSoundSet(saveSound);
      dispatch(setSoundLoaded(load));
    };
    preload();
  }, []);

  useEffect(() => {
    if (play && soundSet[currentSoundID]) {
      soundSet[currentSoundID].play();
      setPrevSound((prev: any) => {
        if (prev && soundSet[currentSoundID] !== prev) {
          prev.pause();
        }
        return soundSet[currentSoundID];
      });
    }
  }, [currentSoundID, soundSet, play]);
};

export default useSoundLoad;
